import { Fragment } from 'react';
import { EditPrompt } from './EditPrompt';
import { PromptLibraryDialog } from '../PromptLibraryDialog';
import { usePromptLibrary } from '../PromptLibraryProvider';
import { DeletePromptDialog } from '../PromptLibrarySelect/DeletePrompt/DeletePromptDialog';
export function PromptLibraryModal() {
    const { view, onClose } = usePromptLibrary();
    return (<Fragment>
      {view === 'library' && <PromptLibraryDialog onClose={onClose}/>}
      {view === 'confirmDelete' && <DeletePromptDialog />}
      {view === 'edit' && <EditPrompt />}
    </Fragment>);
}
